/* eslint-disable prettier/prettier */

const PrintElements = (function() {
  'use strict';

  const hideFromPrintClass = 'pe-no-print';
  const preservePrintClass = 'pe-preserve-print';
  const preserveAncestorClass = 'pe-preserve-ancestor';
  const bodyElementName = 'BODY';

  const _hide = element => {
    if (!element.classList.contains(preservePrintClass)) {
      element.classList.add(hideFromPrintClass);
    }
  };

  const _preserve = (element, isStartingElement) => {
    element.classList.remove(hideFromPrintClass);
    element.classList.add(preservePrintClass);
    if (!isStartingElement) {
      element.classList.add(preserveAncestorClass);
    }
  };

  const _clean = element => {
    element.classList.remove(hideFromPrintClass);
    element.classList.remove(preservePrintClass);
    element.classList.remove(preserveAncestorClass);
  };

  const _walkSiblings = (element, callback) => {
    let sibling = element.previousElementSibling;
    while (sibling) {
      callback(sibling);
      sibling = sibling.previousElementSibling;
    }
    sibling = element.nextElementSibling;
    while (sibling) {
      callback(sibling);
      sibling = sibling.nextElementSibling;
    }
  };

  const _attachPrintClasses = (element, isStartingElement) => {
    _preserve(element, isStartingElement);
    _walkSiblings(element, _hide);
  };

  const _cleanup = (element, isStartingElement) => {
    _clean(element);
    _walkSiblings(element, _clean);
  };

  const _walkTree = (element, callback) => {
    let currentElement = element;
    callback(currentElement, true);
    currentElement = currentElement.parentElement;
    while (currentElement && currentElement.nodeName !== bodyElementName) {
      callback(currentElement, false);
      currentElement = currentElement.parentElement;
    }
  };

  const _print = elements => {
    for (let i = 0; i < elements.length; i++) {
      _walkTree(elements[i], _attachPrintClasses);
    }
    window.print();
    for (let i = 0; i < elements.length; i++) {
      _walkTree(elements[i], _cleanup);
    }
  };

  return {
    print: _print,
  };
})();

export default PrintElements;

// Usage: import PrintElements from '~/plugins/print.js';
// PrintElements.print([node])
// example found in. CartSummary component
